export function keysOf(obj) {
  return Object.keys(obj);
}